import "./AxeboxEdge.module.css";
import Header from "@/reusable_sections/Header";
import OurNarrative from "./sections/OurNarrative";
import CoreValues from "./sections/CoreValues";
import MeetTheStrategists from "./sections/MeetTheStrategists";
import Footer from "@/reusable_sections/Footer";
export default function AxeboxEdgePage() {
  return <div>
      <Header />
      <OurNarrative />
      <CoreValues />
      <MeetTheStrategists />
      <Footer />
    </div>;
}